// extracted by mini-css-extract-plugin
export var inline = "NavSocialMedia-module--inline--a82ea";
export var socialsLabel = "NavSocialMedia-module--socialsLabel--225d0";